import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';

import { useCommentsToggleFocus } from './surface/toggle-focus-context';

type CommentsHeaderActionProps = {
    /** Open comments, shown after the label when there are any. */
    readonly count?: number;
    readonly isOpen: boolean;
    readonly onToggle: () => void;
};

export const CommentsHeaderAction: FunctionComponent<CommentsHeaderActionProps> = ({ count = 0, isOpen, onToggle }) => {
    const translate = useTranslate();
    const { registerCommentsToggle } = useCommentsToggleFocus();

    return (
        <Button
            ref={registerCommentsToggle}
            aria-pressed={isOpen}
            data-testid="comments-header-action"
            isActive={isOpen}
            size="sm"
            variant="secondary"
            onClick={onToggle}
        >
            {translate('pages.job-architecture-v2.comments.header-action.label')}
            {count > 0 ? <span className="ml-xs tabular-nums">{count}</span> : null}
        </Button>
    );
};
